import { reactive } from 'vue'
import type { Implementation, ImplementationStatus, ImplementationType } from '@/types'

export interface ImplementationsState {
  implementations: Implementation[]
  selectedImplementation: Implementation | null
  isLoading: boolean
  error: string | null
  filters: {
    search: string
    projectId: string
    applicationId: string
    status: ImplementationStatus | ''
    type: ImplementationType | ''
  }
}

export const getInitialState = (): ImplementationsState => ({
  implementations: [],
  selectedImplementation: null,
  isLoading: false,
  error: null,
  filters: {
    search: '',
    projectId: '',
    applicationId: '',
    status: '',
    type: '',
  },
})

export const createState = (): ImplementationsState => {
  return reactive(getInitialState())
}

export const resetState = (state: ImplementationsState): void => {
  const initial = getInitialState()
  state.implementations = initial.implementations
  state.selectedImplementation = initial.selectedImplementation
  state.isLoading = initial.isLoading
  state.error = initial.error
  state.filters = initial.filters
}
